import React from 'react';
import { VpLoader } from '@vtmn-play/react';
import type { VpLoaderProps } from '@vtmn-play/react';

import styles from './Loader.module.css';

export const Loader = (props: VpLoaderProps) => (
  <div className={styles.loader}>
    <VpLoader {...props} />
  </div>
);
